/**
 * Client-side portal hostname check. Keep in sync with PORTAL_HOST / parsePortalHosts (server).
 * Set NEXT_PUBLIC_PORTAL_HOST to the same comma-separated list as PORTAL_HOST for local dev.
 */
export function parsePortalHostsClient(): string[] {
  const raw = (process.env.NEXT_PUBLIC_PORTAL_HOST || 'portal.sigmasense.pk').trim()
  if (!raw) return ['portal.sigmasense.pk']
  return raw
    .split(',')
    .map((h) => h.trim().toLowerCase().replace(/^https?:\/\//, '').split('/')[0].split(':')[0])
    .filter(Boolean)
}

export function isPortalSurfaceClient(): boolean {
  if (typeof window === 'undefined') return false
  const host = window.location.hostname.toLowerCase()
  return parsePortalHostsClient().includes(host)
}
